import React from "react";
import "./heroProjects.css";
import heroBg from "../image/background-project.jpeg";
import build1 from "../image/build1.png";
import build2 from "../image/build2.png";
import build3 from "../image/build3.png";
import project1 from "../image/project1.png";
import project2 from "../image/project2.png";
import project3 from "../image/project3.png";
import project4 from "../image/project4.png";
import project5 from "../image/project44.jpeg";
import project6 from "../image/project6.png";
import project7 from "../image/project7.png";
import before1 from "../image/before1.jpeg";
import after1 from "../image/after1.jpeg";

const marqueeColumns = [
  {
    direction: "down",
    images: [
      { src: build1, alt: "Luxury project exterior" },
      { src: project1, alt: "Modern interior project" },
      { src: project4, alt: "Bungalow facade project" },
      { src: before1, alt: "Construction progress view" },
    ],
  },
  {
    direction: "up",
    images: [
      { src: build2, alt: "Residential construction project" },
      { src: project2, alt: "Premium design project" },
      { src: project5, alt: "Large residence project" },
      { src: after1, alt: "Completed project finish" },
    ],
  },
  {
    direction: "down",
    images: [
      { src: build3, alt: "Contemporary villa project" },
      { src: project3, alt: "Project detail view" },
      { src: project6, alt: "Project architecture detail" },
      { src: project7, alt: "Finished project elevation" },
    ],
  },
];

const HeroProjects = ({ openContactModal, openMeetingModal }) => {
  const primaryAction = openContactModal || openMeetingModal || (() => {});
  const title = "We transform your vision into reality";

  return (
    <section className="hp-wrapper">
      <div
        className="hp-bg"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hp-overlay"></div>
        <div className="hp-noise"></div>
        <div className="hp-layout">
          <div className="hp-content">
            <p className="hp-subtitle">
              12+ years of expertise in architecture & construction
            </p>

            <h1 className="hp-title">
              {title.split("").map((char, index) => (
                <span key={index} style={{ animationDelay: `${index * 0.03}s` }}>
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </h1>

            <div className="hp-actions">
              <button className="hp-btn" onClick={primaryAction}>
                Let's Consult
              </button>
            </div>
          </div>

          <div className="hp-visual" aria-hidden="true">
            {marqueeColumns.map((column, columnIndex) => (
              <div
                key={columnIndex}
                className={`hp-marquee-column hp-marquee-${column.direction}`}
              >
                <div className="hp-marquee-track">
                  {[...column.images, ...column.images].map((item, imageIndex) => (
                    <div key={`${columnIndex}-${imageIndex}`} className="hp-marquee-card">
                      <img src={item.src} alt={item.alt} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroProjects;
